import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Problem } from "@/components/landing/Problem";
import { Differentiation } from "@/components/landing/Differentiation";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Product } from "@/components/landing/Product";
import { CompanyBenefits } from "@/components/landing/CompanyBenefits";
import { EmployeeBenefits } from "@/components/landing/EmployeeBenefits";
import { ROI } from "@/components/landing/ROI";
import { Privacy } from "@/components/landing/Privacy";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Hero />
      <ROI />
      <Problem />
      <Differentiation />
      <HowItWorks />
      <Product />
      <CompanyBenefits />
      <EmployeeBenefits />
      <Privacy />
      <FinalCTA />
      <Footer />
    </div>
  );
}
